import glbExtends from '@/utils/glbExtends';
const _name = 'glb';
// 往 window 上添加一个自定义属性
// 将 glb 属性定义为只读，并将该对象冻结，防止被修改
Object.defineProperty(window, _name, {
    value: Object.freeze({ ...window[_name], ...glbExtends }),
    writable: false,
    enumerable: true,
    configurable: false,
});
